// @TODO: production database table doesn't match these ids...think we can get rid of the tables in prod
// @TODO: these should come from db instead of living here? (already in db and in redux under `minigames` reducer)
/**
 * Ryan O'Dowd
 * 2022-05-06
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import FillInTheBlanks from '@containers/Practice/FillInTheBlanks';
// @TODO: import FinishTheVerse from './containers/Practice/FinishTheVerse';
import FirstLetters from '@containers/Practice/FirstLetters';
import OrderTheVerses from '@containers/Practice/OrderTheVerses';
import References from '@containers/Practice/References';

const minigames = (i18n) => [ // @TODO: these could have better names; // @TODO: add easy, medium, hard descriptions for each
  {
    id: 1,
    name: i18n('test'),
    // @TODO: component: Test,
  },
  {
    id: 2,
    name: i18n('fillInTheBlanks'),
    description: i18n('fillInTheBlanksDescription'),
    instructions: [
      i18n('fillInTheBlanksInstructionsOne'),
      i18n('fillInTheBlanksInstructionsTwo'),
    ],
    component: FillInTheBlanks,
  },
  {
    id: 3, // @TODO: update database to switch id
    name: i18n('orderTheVerses'),
    description: i18n('orderTheVersesDescription'),
    instructions: [
      i18n('orderTheVersesInstructionsOne'),
      i18n('orderTheVersesInstructionsTwo'),
    ],
    component: OrderTheVerses,
  },
  {
    id: 4, // @TODO: update database to switch id
    name: i18n('references'),
    description: i18n('referencesDescription'),
    instructions: [],
    component: References,
  },
  {
    id: 5,
    name: i18n('firstLetters'),
    description: i18n('firstLettersDescription'),
    instructions: [],
    component: FirstLetters,
  },
  /* @TODO:
  {
    id: 6,
    name: 'Finish the verse', i18n
    description: 'The first 3 words of the verse are provided.', i18n
    component: FinishTheVerse,
  },
  // @TODO: 7 is audio
  {
    id: 8,
    name: 'TODO',
    description: 'TODO',
    component: TODO,
  },
  */
];

export default minigames;
